<template>
    <div style="display: inline-block" :test_id="test_id">
        <div
            :style="{ color: $Utils.colors[color] }"
            class="list-action"
            @click="$emit('click')"
        >
            <div
                class="list-action-icon"
                v-if="materialIcon"
                :style="{ background: $Utils.colors[color] }"
            >
                <i class="material-icons">{{ materialIcon }}</i>
            </div>
            {{ $t(label) }}
        </div>
    </div>
</template>
<script>
import { test_id } from '@/globalProps'

export default {
    props: {
        color: {
            type: String,
            default: ''
        },
        label: {
            type: String,
            default: ''
        },
        materialIcon: {
            type: String,
            default: ''
        },
        test_id
    }
}
</script>
<style lang="scss" scoped>
.list-action {
    display: flex;
    align-items: center;
    margin-left: 0;
    margin-right: 1rem;
    font-family: $input-family;
    cursor: pointer;
    transition: $ease;
    color: $action-accent;
    margin-left: 1rem;
    user-select: none;

    &:hover {
        transform: translateY(0.1rem);
    }
}
</style>
